export default function Pagination() {
  return {
    controlHeightSM: 40,
    controlHeight: 47,
    controlHeightLG: 54
  }
}
